// extracted by mini-css-extract-plugin
var _1 = "CommentThreadCompactAvatar-module__avatar--cuwY0";
export { _1 as "avatar" }
